/**
 * Filtre la navigation selon le plan d'abonnement (manager / staff / agent).
 * Les entrées sans `planRequires` restent visibles si les permissions le permettent.
 *
 * @param {object} nav - entrée NavigationConfig
 * @param {object|null|undefined} plan - objet retourné par normalizePlanFromSubscription / useManagerPlanEntitlements
 * @param {boolean} [planReady=true] - si false, toute entrée avec planRequires reste cachée (chargement abonnement)
 */
export function navItemAllowedByPlan(nav, plan, planReady = true) {
	if (nav?.planRequires && planReady === false) {
		return false;
	}
	if (!plan || !nav?.planRequires) return true;
	switch (nav.planRequires) {
		case 'dialer':
			return !!plan.dialer;
		case 'callBroadcast':
			return !!plan.callBroadcast;
		case 'agentAccess':
			return !!plan.agentAccess;
		case 'agentIa':
			return plan.agentIa !== false;
		default:
			return true;
	}
}
